import { Grid } from "@mui/material";
import React from "react";
import { InputWithErrorLabel as Input } from "components/haven-design/form/inputs";
import { extendedStatesList } from "components/haven-design/state-picker";
import { MaterialFormikSelectAutocomplete as SelectAutocomplete } from "components/haven-design/form/select";

type AddressFieldsProps = {
  // When false the fields are optional and labelled as such. Defaults to true.
  required?: boolean;
};

const label = (text: string, required: boolean): string =>
  (required ? text : `${text} (optional)`);

const AddressFields: React.FC<AddressFieldsProps> = ({ required = true }) => (
  <>
    <Grid size={{ xs: 12 }}>
      <Input margin="none" label={label("Address", required)} required={required} name="address1" />
    </Grid>
    <Grid size={{ xs: 12 }}>
      <Input margin="none" label={label("Address 2", required)} name="address2" />
    </Grid>
    <Grid size={{ xs: 12, md: 5 }}>
      <Input margin="none" label={label("City", required)} required={required} name="city" />
    </Grid>
    <Grid size={{ xs: 6, md: 3 }}>
      <SelectAutocomplete
        id="state"
        margin="none"
        name="state"
        placeholder={required ? "State *" : "State"}
        title={label("State", required)}
        required={required}
        fullWidth
        options={extendedStatesList}
      />
    </Grid>
    <Grid size={{ xs: 6, md: 3 }}>
      <Input
        margin="none"
        label={label("Zip", required)}
        required={required}
        name="zip"
        slotProps={{ htmlInput: { maxLength: "5" } }}
      />
    </Grid>
  </>
);

export default AddressFields;
